/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { JSX, FC } from "react";
import { MarkerClustererF, MarkerClustererProps } from "@react-google-maps/api";
import { Clusterer } from "@react-google-maps/marker-clusterer";

interface ClusterProps extends MarkerClustererProps {
  children: (markerClusterer: Clusterer | undefined) => JSX.Element;
  isMagnify?: boolean;
}

/**
 * Customized MarkerClustererF not to cluster when in magnify.
 * @param {ClusterProps} props
 * @return {JSX.Element}
 */
export const MyMarkerClustererF: FC<ClusterProps> = ({
  isMagnify,
  children,
  ...props
}) => {
  return (
    <>
      {isMagnify ? (
        <>{children(undefined)}</>
      ) : (
        <MarkerClustererF {...props}>{children}</MarkerClustererF>
      )}
    </>
  );
};
